/*** IMPORTS FROM imports-loader ***/
var shim = require("es5-shim/es5-shim");
var sham = require("es5-shim/es5-sham");

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _config = require('../config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

module.exports = function (scb) {
    return new Tracker(scb);
};

function Tracker(scb) {

    var projectId,
        // 数据分析项目id int
    visitorId,
        page,
        _keepOnlineTimer,
        hasSendExitEvent,
        hasInited,
        _actHashId,
        _hasTriggerLeaveEvent = false,
        _leaveEventArr = [],
        _isInReEntryPage = false,
        _ReEntryCbArr = [],
        properties = {},
        _page_view_id = 0,
        _name = '',
        _deviceType = isMobile() ? 'mobile' : 'pc',
        _avatar = '',
        _session_id = '';

    var API_UPDATE_VISITOR_PROPERTIES = _config2["default"].API_DOMAIN + '/m/api/visitor-event-tracking/v1/activity/visitor/properties',
        // 设置观众属性 这里替换了新接口
    API_ON_PAGE_VIEW = _config2["default"].API_DOMAIN + '/analytics/api/on_page_view',
        // 这个接口没用了 去掉
    API_ONLINE = _config2["default"].API_DOMAIN + '/m/api/visitor-event-tracking/v1/activity/visitor/page_online',
        // 在线打点 替换了新接口
    API_ON_PAGE_EXIT = _config2["default"].API_DOMAIN + '/user/api/logout',
        // 离开页面 后面拼接acthashid
    API_ON_PAGE_EVENT = _config2["default"].API_DOMAIN + '/m/api/visitor-event-tracking/v1/activity/visitor/page_event'; // 数据上报 替换了新接口

    return {
        keepOnlineTimeGap: 20 * 1000,
        init: function init(newProjectId, newVisitorId, newPage, actHashId) {
            this.setProjectId(newProjectId);
            this.setVisitorId(newVisitorId);
            this.setPage(newPage);
            _actHashId = actHashId;
            'function' === typeof scb && scb();
        },
        setProjectId: function setProjectId(newProjectId) {
            projectId = +newProjectId;
        },
        getProjectId: function getProjectId() {
            return projectId;
        },
        setSessionId: function setSessionId(id) {
            _session_id = id;
        },
        getSessionId: function getSessionId() {
            return _session_id;
        },
        setProperties: function setProperties(param) {
            properties = param;
        },
        getProperties: function getProperties() {
            return properties;
        },
        setPage: function setPage(newPage) {
            var pref = '/activity/';
            if (newPage.indexOf(pref) === 0) {
                page = newPage;
            } else {
                page = pref + newPage;
                // eslint-disable-next-line
                console && console.warn && console.warn('data tracker needs page param as "/activity/${actHashId}"');
            }
        },
        getPage: function getPage() {
            return page;
        },
        setVisitorId: function setVisitorId(newVisitorId) {
            visitorId = '' + newVisitorId;
        },
        getVisitorId: function getVisitorId() {
            return visitorId;
        },
        startDataTracker: function startDataTracker(properties, session_id) {
            var _self = this;
            properties = !properties ? {} : properties;
            this.setSessionId(session_id);
            this.setProperties(properties);
            this.updateProperties(properties);
            this.keepOnlineTimer();
            hasInited = true;
            _self.sendCookiePhone();
            //_self.shouldUpdateUseractPhone();
            var referVisitorId = getParams().referVisitorId || '';
            if (referVisitorId) {
                _self.triggerEvent({
                    category: 'interact',
                    action: 'share',
                    label: getOrigintype(),
                    value: getParams().referVisitorId || '',
                    session_id: session_id
                });
            }
        },
        getParams: getParams,
        getOrigintype: getOrigintype,
        get_cookie: get_cookie,
        updateProperties: function updateProperties(properties) {
            var _self = this;
            properties = !properties ? {} : properties;
            if (properties.name) {
                _name = properties.name;
            }
            if (properties.avatar) {
                _avatar = properties.avatar;
            }
            update_visitor_properties({
                properties: properties,
                session_id: _self.getSessionId()
            });
        },
        sendCookiePhone: function sendCookiePhone() {
            var actHashId = _actHashId;
            var cookieName = 'phone_tracker_' + actHashId;
            var cookieValue = get_cookie(cookieName);
            if (!cookieValue) {
                return;
            }
            this.triggerEvent({
                category: 'interact',
                action: 'phone',
                label: '' + cookieValue,
                session_id: this.getSessionId()
            }, function () {
                DelCookie(cookieName);
            });
        },
        /**
         * keep online 定时器
         */
        keepOnlineTimer: function keepOnlineTimer() {
            var _self = this;
            if (_keepOnlineTimer) {
                return;
            }

            _keepOnlineTimer = setInterval(function () {
                !hasSendExitEvent && _self.keepOnline();
            }, _self.keepOnlineTimeGap);

            [{
                target: window,
                event: 'beforeunload',
                cb: function cb() {
                    _self.triggerOnLeaveEvent();
                    _self.keepOnline(true);
                    _self.leavePage();
                }
            }, {
                target: window,
                event: 'unload',
                cb: function cb() {
                    _self.triggerOnLeaveEvent();
                    _self.keepOnline(true);
                    _self.leavePage();
                }
            }, {
                target: window,
                event: 'pagehide',
                cb: function cb() {
                    _self.keepOnline();
                }
            }, {
                target: document,
                event: 'visibilitychange',
                cb: function cb() {
                    _self.keepOnline();
                }
            }].forEach(function (v) {
                addEvent(v.target, v.event, v.cb);
            });
        },
        keepOnline: function keepOnline(sync) {
            var _self = this;
            var data = {
                project_id: +_self.getProjectId(),
                page: '' + _self.getPage(),
                visitor_id: '' + _self.getVisitorId(),
                name: '' + _name,
                avator: '' + _avatar,
                device: '' + _deviceType,
                session_id: _self.getSessionId()
            };
            !hasSendExitEvent && keep_online(data, !sync);
        },
        triggerOnLeaveEvent: function triggerOnLeaveEvent() {
            if (_hasTriggerLeaveEvent) {
                return;
            }
            for (var i = 0; i < _leaveEventArr.length; i++) {
                if ('function' === typeof _leaveEventArr[i]) {
                    _leaveEventArr[i]();
                }
            }
            _hasTriggerLeaveEvent = true;
        },
        /**
         * 
         * @param {*} fn or fn[]
         */
        onLeave: function onLeave(fn) {
            if ('function' === typeof fn) {
                _leaveEventArr.push(fn);
            } else if (fn instanceof Array) {
                for (var i = 0; i < fn.length; i++) {
                    if ('function' === typeof fn[i]) {
                        _leaveEventArr.push(fn[i]);
                    }
                }
            }
        },
        onLeaveCancel: function onLeaveCancel(fn) {
            _leaveEventArr = _leaveEventArr.filter(function (v) {
                return v !== fn;
            });
        },
        leavePage: function leavePage() {
            if (hasSendExitEvent) {
                return;
            }
            var _self = this;
            var data = {
                // project_id: +(_self.getProjectId()),
                page: '' + _self.getPage(),
                page_view_id: _page_view_id,
                session_id: _self.getSessionId()
            };
            on_page_exit(data);
            hasSendExitEvent = true;
        },
        /**
         * project_id 项目id int
            page 页面key string 
            category 事件分类 string
            action 事件key string
            label 事件标签 string
            value 事件值（int）
         * @param {*} data 
         */
        triggerEvent: function triggerEvent(data, opt) {
            var successCallback = 'function' === typeof opt ? opt : opt && 'function' === typeof opt.success ? opt.success : undefined;
            var async = opt && 'undefined' !== typeof opt.async ? opt.async : true;
            if (!hasInited || hasSendExitEvent) {
                return;
            }
            var _self = this;
            var project_id = typeof data.project_id === 'undefined' ? _self.getProjectId() : data.project_id;
            var page = typeof data.page === 'undefined' ? _self.getPage() : data.page;
            var value = typeof data.value === 'undefined' ? 1 : data.value;
            var sessionId = typeof data.session_id === 'undefined' ? this.getSessionId() : data.session_id;
            sendEvent({
                project_id: project_id,
                page: page,
                category: data.category,
                action: data.action,
                label: data.label || '',
                value: value,
                session_id: sessionId
            }, {
                async: async,
                success: successCallback
            });
        },
        destroy: function destroy() {
            if (_keepOnlineTimer) {
                clearInterval(_keepOnlineTimer);
            }
            var _self = this;
            _self.triggerOnLeaveEvent();
            _self.keepOnline();
            _self.leavePage();
        }
    };

    /**
     * project_id 数据分析项目id int
        visitor_id 访客id string
        properties 访客自定义属性 object
     * @param {*} data 
     */
    function update_visitor_properties(data) {
        ajax(API_UPDATE_VISITOR_PROPERTIES + '?act_id=' + _actHashId, {
            method: 'PUT',
            data: data
        });
    }

    /**
     * 进入页面
     * @param {*} data 
     */
    function on_page_view(data, opt) {
        ajax(API_ON_PAGE_VIEW, {
            method: 'POST',
            data: {
                project_id: +data.project_id, // int
                location: window.location.href,
                title: document.title,
                page: '' + data.page
            },
            async: opt && 'undefined' !== opt.async ? opt.async : true,
            success: function success(res) {
                try {
                    var data = JSON.parse(res);
                    if (data.errcode === 1000) {
                        _page_view_id = data.page_view_id;
                    }
                } catch (e) {/**/}
                typeof opt === 'function' && opt(res);
                opt && 'function' === typeof opt.success && opt.success(res);
            }
        });
    }

    function reEntryPage(cb) {
        _ReEntryCbArr.push(cb);
        if (_isInReEntryPage) {
            return;
        }
        _isInReEntryPage = true;
        on_page_view({
            project_id: projectId,
            page: page
        }, {
            async: false,
            success: function success() {
                for (var i = 0; i < _ReEntryCbArr.length; i++) {
                    var item_cb = _ReEntryCbArr[i];
                    'function' === typeof item_cb && item_cb();
                }
                _ReEntryCbArr = [];
                _isInReEntryPage = false;
            }
        });
    }

    /**
     * 定时刷新
     * @param {*} data 
     */
    function keep_online(data, async) {
        ajax(API_ONLINE + '?act_id=' + _actHashId, {
            method: 'POST',
            data: {
                name: data.name,
                visitor_id: data.visitor_id,
                avator: data.avator,
                device: data.device,
                page: data.page,
                session_id: data.session_id
            },
            async: async,
            success: function success(d) {
                try {
                    if ('string' === typeof d) {
                        d = JSON.parse(d);
                    }
                } catch (e) {
                    d = d || '';
                }
                if (d.errcode === 1634) {
                    reEntryPage(function () {
                        keep_online(data, async);
                    });
                }
            }
        });
    }

    /**
     * 离开事件 同步请求
     * @param {*} data 
     */
    function on_page_exit(data) {
        ajax(API_ON_PAGE_EXIT + '?act_id=' + _actHashId, {
            method: 'POST',
            data: data,
            async: false
        });
    }

    function sendEvent(data, opt) {
        ajax(API_ON_PAGE_EVENT + '?act_id=' + _actHashId, {
            method: 'POST',
            data: {
                page: '' + data.page,
                category: '' + data.category,
                action: '' + data.action,
                label: '' + data.label,
                value: +data.value,
                from_value: '',
                session_id: data.session_id
            },
            success: function success(d) {
                try {
                    if ('string' === typeof d) {
                        d = JSON.parse(d);
                    }
                } catch (e) {
                    d = d || '';
                }
                if (d.errcode === 1634) {
                    reEntryPage(function () {
                        sendEvent(data, opt);
                    });
                    return;
                }
                'function' === typeof opt.success && opt.success();
            },
            async: opt.async
        });
    }

    function getOrigintype() {
        var ref = document.referrer;
        var refererHost = (ref.split('/')[2] || '').split(':')[0];
        var currentHost = window.location.host;
        var params = getParams();
        var ua = navigator.userAgent.toLowerCase();
        if (ua.indexOf('dingtalk') !== -1) {
            refererHost = 'dingding';
        }
        var origin = params.from || '';
        var queryStringChannel = params.channel || '';
        if (origin === '') {
            if (refererHost.indexOf('weibo.com') !== -1) {
                origin = 'weibo';
            } else if (refererHost.indexOf('qq.com') !== -1) {
                origin = 'qq';
            } else if (refererHost.indexOf('dingding') !== -1) {
                origin = 'dingding';
            } else if (refererHost === currentHost) {
                origin = 'direct';
            } else if (refererHost) {
                origin = refererHost;
            } else {
                origin = 'direct';
            }
        }
        if (queryStringChannel === 'invite_card') {
            origin = 'invite_card';
        }
        return origin;
    }

    function getParams() {
        var ret = {};
        var seg = window.location.search.replace(/^\?/, '').split('&').filter(function (v) {
            if (v !== '' && v.indexOf('=')) {
                return true;
            }
        });
        seg.forEach(function (element) {
            var idx = element.indexOf('=');
            var key = element.substring(0, idx);
            var val = element.substring(idx + 1);
            ret[key] = val;
        });
        return ret;
    }

    /**
     * 封装绑定事件
     * @param {*} elem 
     * @param {*} type 
     * @param {*} handler 
     */
    function addEvent(elem, type, handler) {
        if (window.addEventListener) {
            // eslint-disable-next-line
            addEvent = function addEvent(elem, type, handler) {
                elem.addEventListener(type, handler, false);
            };
        } else if (window.attachEvent) {
            // eslint-disable-next-line
            addEvent = function addEvent(elem, type, handler) {
                elem.attachEvent('on' + type, handler);
            };
        }

        addEvent(elem, type, handler);
    }

    function get_cookie(name) {
        var arr = document.cookie.match(new RegExp('(^| )' + name + '=([^;]*)(;|$)'));
        if (arr != null) {
            return unescape(arr[2]);
        } else {
            return null;
        }
    }

    /**
     * 设置当日零点过期的cookie
     * @param {*} name 
     * @param {*} value 
     */
    // function set_cookie(name, value) {
    //     var curDate = new Date();

    //     //当前时间戳
    //     var curTamp = curDate.getTime();

    //     //当日凌晨的时间戳,减去一毫秒是为了防止后续得到的时间不会达到00:00:00的状态
    //     var curWeeHours = new Date(curDate.toLocaleDateString()).getTime() - 1;

    //     //当日已经过去的时间（毫秒）
    //     var passedTamp = curTamp - curWeeHours;

    //     //当日剩余时间
    //     var leftTamp = 24 * 60 * 60 * 1000 - passedTamp;
    //     var leftTime = new Date();
    //     leftTime.setTime(leftTamp + curTamp);
    //     //创建cookie
    //     document.cookie = name + '=' + escape(value + ',') + ';expires=' + leftTime.toGMTString();
    // }

    //两个参数，一个是cookie的名子，一个是值
    function SetCookie(name, value) {
        // eslint-disable-line
        var Days = 30; //此 cookie 将被保存 30 天
        var exp = new Date(); //new Date("December 31, 9998");
        exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
        document.cookie = name + '=' + encodeURIComponent(value) + ';expires=' + exp.toGMTString() + ';path=/';
    }
    //取cookies函数
    function GetCookie(name) {
        var arr = document.cookie.match(new RegExp('(^| )' + name + '=([^;]*)(;|$)'));
        if (arr != null) return decodeURIComponent(arr[2].replace(/\+/g, '%20'));
        return null;
    }
    //删除cookie
    function DelCookie(name) {
        var exp = new Date();
        exp.setTime(exp.getTime() - 1);
        var cval = GetCookie(name);
        if (cval != null) document.cookie = name + '=' + cval + ';expires=' + exp.toGMTString() + '; path=/';
    }

    /**
     * 封装的ajax
     * @param {*} url 
     * @param {*} option 
     */
    function ajax(url, option) {
        // 没有get请求，直接写死post
        if (option.method == 'POST') {
            Fetcher.Post(url, (0, _stringify2["default"])(option.data), function (data) {
                try {
                    typeof option.success === 'function' && option.success(data);
                } catch (e) {
                    typeof option.fail === 'function' && option.fail(data);
                }
                typeof option.complete === 'function' && option.complete(data);
            }, {
                'User-Agent': navigator.userAgent,
                'Referer': document.referrer,
                'Content-Type': 'application/json'
            });
        } else if (option.method == 'PUT') {
            Fetcher.Put(url, (0, _stringify2["default"])(option.data), function (data) {
                try {
                    typeof option.success === 'function' && option.success(data);
                } catch (e) {
                    typeof option.fail === 'function' && option.fail(data);
                }
                typeof option.complete === 'function' && option.complete(data);
            }, {
                'User-Agent': navigator.userAgent,
                'Referer': document.referrer,
                'Content-Type': 'application/json'
            });
        }
    }

    function isMobile() {
        return (/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i.test(navigator.userAgent)
        );
    }
}



/*****************
 ** WEBPACK FOOTER
 ** ./application/components/modules/Tracker.js
 ** module id = 145
 ** module chunks = 1
 **/